/* eslint-disable react/require-default-props,react/no-danger */
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Fuse from 'fuse.js';
import { Link } from 'react-router-dom';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Flex from '../../common/Flex';
import FalconCloseButton from '../../common/CloseButton';
import { isIterableArray } from '../../helpers/utils';
import Avatar from '../../common/Avatar';
import { CiatAppContext } from '../../../../providers';
import { metaBackends } from '../../../../meta';

function MediaSearchContent({ item }) {
  return (
    <Dropdown.Item className="px-x1 py-2" as={Link} to={item.url}>
      <Flex alignItems="center">
        {item.file && (
          <div className="file-thumbnail">
            <img src={item.img} alt="" className={item.imgAttrs.class} />
          </div>
        )}
        {item.icon && (
          <Avatar src={item.icon.img} size="l" className={item.icon.status} />
        )}

        <div className="ms-2">
          <h6 className="mb-0">{item.title}</h6>
          <p
            className="fs--2 mb-0"
            dangerouslySetInnerHTML={{ __html: item.text || item.time }}
          />
        </div>
      </Flex>
    </Dropdown.Item>
  );
}

function SearchBox() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState('');

  const { currentUser } = useContext(CiatAppContext);
  const menuSections = Object.values(currentUser.available_sections);
  const searchContainerRef = useRef(null);

  const autoCompleteItem = menuSections.reduce((res, el, idx) => {
    const item = el.children;
    if (item) {
    // eslint-disable-next-line array-callback-return,consistent-return
      item.map((subItem) => {
        if (subItem.children) {
          subItem.children.map((elMenu) => {
            const newItem = {
              id: idx,
              label: elMenu.label,
              name: elMenu.name,
              url: elMenu.url,
              resource: elMenu.resource,
              section: el.label,
            };
            if (!res
              .some((existingItem) => existingItem.id === newItem.id
                && existingItem.label === newItem.label)) {
              res.push(newItem);
            }
            return res;
          });
          return res;
        }
        const newItem = {
          id: idx,
          label: subItem.label,
          name: subItem.name,
          resource: subItem.resource,
          section: el.label,
        };
        if (!res
          .some((existingItem) => existingItem.id === newItem.id
            && existingItem.label === newItem.label)) {
          res.push(newItem);
        }
      });
      return res;
    }
    return res;
  }, []);

  const [resultItem, setResultItem] = useState(menuSections);

  const cMenu = resultItem.reduce(
    // eslint-disable-next-line array-callback-return
    (res, el) => {
      const cSection = el.section;

      if (res[cSection]) {
        res[cSection] = [
          ...res[el.section],
          el,
        ];
        return res;
      }

      res[cSection] = [el];
      return res;
    },
    {},
  );
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        searchContainerRef.current
        && !searchContainerRef.current.contains(event.target)
      ) {
        setSearchInputValue('');
        setDropdownOpen(false);
      }
    };

    window.addEventListener('click', handleOutsideClick);

    return () => {
      window.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const handleMenuItemClick = () => {
    setSearchInputValue('');
    setDropdownOpen(false);
  };
  // threshold - Прикольна штука! Має значення від 0 до 1. 0 - точне співпадіння, 1 - будь-що.
  // По замовчанню 0.6. Якщо залишити "по замовчанню", то попадає буде багато сміття.
  const fuseJsOptions = {
    includeScore: true,
    threshold: 0.3,
    ignoreLocation: true,
    keys: ['label'],
  };

  const searchResult = new Fuse(autoCompleteItem, fuseJsOptions)
    .search(searchInputValue)
    .map((item) => item.item);

  useEffect(() => {
    if (searchInputValue) {
      setResultItem(searchResult);
      // eslint-disable-next-line no-unused-expressions
      isIterableArray(searchResult) && setDropdownOpen(true);
    } else {
      setResultItem(autoCompleteItem);
    }

    // eslint-disable-next-line
  }, [searchInputValue]);

  return (
    <Dropdown show={dropdownOpen} className="search-box" ref={searchContainerRef}>
      <Form
        className="position-relative"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Form.Control
          type="search"
          placeholder="Пошук..."
          aria-label="Пошук"
          className="rounded-pill search-input"
          value={searchInputValue}
          onChange={({ target }) => setSearchInputValue(target.value)}
          onFocus={() => setDropdownOpen(true)}
        />
        <FontAwesomeIcon
          icon={faSearch}
          className="position-absolute text-400 search-box-icon"
        />
        {(dropdownOpen || searchInputValue) && (
          <div className="search-box-close-btn-container">
            <FalconCloseButton
              size="sm"
              noOutline
              className="fs--2"
              onClick={() => {
                setSearchInputValue('');
                setDropdownOpen(false);
              }}
            />
          </div>
        )}
      </Form>
      <Dropdown.Menu
        onBlur={() => setDropdownOpen(false)}
      >
        <div className="scrollbar py-3" style={{ maxHeight: '24rem' }}>

          {Object.keys(cMenu).map((elMenu) => (
            <React.Fragment key={elMenu}>
              <Dropdown.Header
                as="h6"
                className="px-x1 pt-0 pb-2 fw-medium"
              >
                {elMenu}
              </Dropdown.Header>

              {isIterableArray(cMenu[elMenu]) && (
                cMenu[elMenu].map((el) => metaBackends[el.resource] && (
                <Dropdown.Item
                  href={`#${metaBackends[el.resource].frontendURL}`}
                  className="fs-0 px-x1 py-1"
                  key={el.name}
                  onClick={handleMenuItemClick}
                >
                  <div
                    className="flex-1 fs--1"
                  >
                    {el.label}
                  </div>
                </Dropdown.Item>
                ))
              )}
              <hr className="text-200 dark__text-900" />
            </React.Fragment>
          ))}

          {resultItem.length === 0 && (
            <p className="fs-1 fw-bold text-center mb-0">Немає результатів.</p>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

MediaSearchContent.propTypes = {
  item: PropTypes.shape({
    catagories: PropTypes.string,
    url: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      img: PropTypes.string.isRequired,
      size: PropTypes.string,
      status: PropTypes.string,
    }),
    title: PropTypes.string,
    text: PropTypes.string,
    img: PropTypes.string,
    time: PropTypes.string,
    file: PropTypes.bool,
    imgAttrs: PropTypes.shape({
      class: PropTypes.string,
    }),
  }).isRequired,
};

export default SearchBox;
